import {
  createGlobalStyle,
  DefaultTheme,
  ThemeProvider,
} from "styled-components/macro";
import styles from "./theme.module.css";
import React from "react";
import { typography } from "@joor/design-system";

export const theme: DefaultTheme = {
  colors: {
    focusedInput: styles.focusedInput,
    negativeData: styles.negativeData,
    primary: styles.primaryColor,
    primary2: styles.primary2Color,
    secondary: styles.secondaryColor,
    secondary2: styles.secondary2Color,
    secondary3: styles.secondary3Color,
    selectedText: styles.selectedText,
    tertiary: styles.tertiaryColor,
    tertiary2: styles.tertiary2Color,
    text: styles.textColor,
  },
  font: {
    family: {
      regular: "'Montserrat', sans-serif",
      numeric: "'Nunito Sans', sans-serif",
    },
    weights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
  },
};

const WorkspacesGlobalStyling = createGlobalStyle`
    body {
      margin: 0px;
      height: 100%;
      padding: 0px;
      ${typography.alpha.primaryInactive.body3};
    }

    #root {
        height: 100vh;
    }
`;

export const Provider: React.FC = ({ children }) => (
  <ThemeProvider theme={theme}>
    <WorkspacesGlobalStyling />
    {children}
  </ThemeProvider>
);
